import { AnnotatorObject } from 'annotator/annotator-types';

type ElementProximityToViewport = {
  above: boolean,
  below: boolean,
  multiplePages: boolean
}

declare const Annotator: AnnotatorObject;

const isAboveViewport = (elementTop: number): boolean => {
  const submissionDocWrap: HTMLElement = document.querySelector('.annotator-submission-doc-wrap');
  // Evaluate top of submission doc wrap to determine the actual top.
  const { top }: DOMRect = submissionDocWrap.getBoundingClientRect();
  // Return true if highlight is above the viewport.
  return elementTop < top;
};

const isBelowViewport = (elementBottom: number): boolean => {
  const annotatorToolbar: HTMLElement | null = document.querySelector('.annotator-toolbar');
  // Evaluate top of annotator toolbar to determine the actual viewport bottom.
  const annotatorToolbarHeight: number = annotatorToolbar ? annotatorToolbar.getBoundingClientRect().height : 0;
  // Return true if highlight is below the viewport.
  return elementBottom > (window.innerHeight - annotatorToolbarHeight);
};

const isMultiPageHighlight = (height: number): boolean => {
  const annotatorToolbar: HTMLElement | null = document.querySelector('.annotator-toolbar');
  // Evaluate height of annotator toolbar to determine the actual viewport bottom.
  const annotatorToolbarHeight: number = annotatorToolbar ? annotatorToolbar.getBoundingClientRect().height : 0;
  const submissionDocWrap: HTMLElement = document.querySelector('.annotator-submission-doc-wrap');
  // Evaluate top of submission doc wrap to determine the actual top.
  const { top } = submissionDocWrap.getBoundingClientRect();
  return height > (window.innerHeight - annotatorToolbarHeight - top);
};

const proximityToViewport = (timestamp: string): ElementProximityToViewport | null => {
  const highlights: NodeListOf<HTMLElement> =
    document.querySelectorAll(`.annotator-submission-doc-wrap [data-timestamp='${timestamp}']`);
  // If highlight is not found, return null.
  if (!highlights.length) return null;
  const { top }: DOMRect = highlights[0].getBoundingClientRect();
  const { bottom }: DOMRect = highlights[highlights.length - 1].getBoundingClientRect();
  const height: number = bottom - top;
  // Return element's proximity to viewport.
  return {
    above: isAboveViewport(top),
    below: isBelowViewport(bottom),
    multiplePages: isMultiPageHighlight(height)
  };
};

const scrollToHighlight = (timestamp: string): void => {
  const elementProximityToViewport: ElementProximityToViewport | null = proximityToViewport(timestamp);
  if (elementProximityToViewport) {
    // Find out if comment is out of the viewport.
    const isOutOfViewport: boolean = Object.values(elementProximityToViewport).some(Boolean);
    // If so, scroll to it and position it either at the top or bottom of the viewport.
    if (isOutOfViewport) {
      const { above, multiplePages } = elementProximityToViewport;
      Annotator.scrollTo(timestamp, above || multiplePages);
    }
  }
};

export default scrollToHighlight;
